<template>
  <div class="flex justify-between items-center">
    <div class="flex flex-col">
      <h2 class="flex items-center">
        <SVG name="warning" css="fill-current text-white w-[18px]"></SVG>
        {{ title }}
      </h2>
      <h4>{{ message }}</h4>
    </div>
    <div class="flex justify-end">
      <div
        class="mr-10 bg-error rounded-full w-[35px] h-[35px] p-2 flex justify-center items-center cursor-pointer hover:opacity-80"
        @click="close()"
      >
        <SVG name="plus" css="rotate-45 fill-current"></SVG>
      </div>
      <div
        class="mr-4 bg-success rounded-full w-[35px] h-[35px] p-2 flex justify-center items-center cursor-pointer hover:opacity-80"
        @click="valide()"
      >
        <SVG name="valider" css="fill-current text-white"></SVG>
      </div>
    </div>
  </div>

  <div class="w-full flex mt-5 bg-g0 rounded-full overflow-hidden">
    <div
      :style="'width: ' + progress + '%;'"
      class="w-full h-[5px] bg-white rounded-full transition-all duration-1000 ease-in-out"
    ></div>
  </div>
</template>

<script lang="ts">
import type { ToastOptions } from "vue3-toastify";
import { toast } from "vue3-toastify";
import { PropType, ref } from "vue";
import API from "@/utils/API";

import SVG from "@/partials/SVG.vue";
import { im } from "mathjs";

export default {
  name: "Action_Toast",
  props: {
    closeToast: Function as PropType<(e?: MouseEvent) => void>,
    toastProps: Object as PropType<ToastOptions>,
    /** -------------- */
    action: {
      type: Object,
      required: true,
    },
  },
  components: {
    SVG,
  },
  setup() {
    return {
      title: $root.$e("Alarme milestone"),
      message: $root.$e(
        "Une alarme a été déclenchée, voulez-vous lancer le vol ?"
      ),
      progress: ref(1),
      idSetInterval: ref(null),
    };
  },

  mounted() {
    this.idSetInterval = setInterval(() => {
      let fiveMinutes = 5 * 60;
      let now = parseInt(new Date().getTime() / 1000);
      let secondeOffset = Date().getTimezoneOffset() * 60;
      let createdAt = new Date(this.action.ach_created_at).getTime();

      now = parseInt(now - secondeOffset);
      createdAt = parseInt(createdAt / 1000);
      let diff = now - createdAt;
      diff = fiveMinutes - diff;
      this.progress = ((diff / 250) * 100).toFixed(0);

      if (now - createdAt > fiveMinutes) {
        this.progress = 0;
        this.closeToast();
      }
    }, 1000);
  },

  unmounted() {
    if (this.idSetInterval) {
      clearInterval(this.idSetInterval.value);
    }
  },

  methods: {
    async close() {
      let r = await API.put("actionhook", {
        ach_id: this.action.ach_id,
        status: false,
      });
      this.closeToast();

      if (r.Result != ENV.API_RESPONSE_VALID) {
        toast.error(
          $root.$e(" Action déjà mis à jour ou délai d'attente expiré"),
          $root.toastConfig
        );
        return;
      }
    },
    /** ------------------- */
    async valide() {
      let r = await API.put("actionhook", {
        ach_id: this.action.ach_id,
        status: true,
      });

      this.closeToast();

      if (r.Result != ENV.API_RESPONSE_VALID) {
        toast.error(
          $root.$e(" Action déjà mis à jour ou délai d'attente expiré"),
          $root.toastConfig
        );
        return;
      }

      r = API.put("flightexecute", {
        FlgId: this.action.flg_id,
      });

      if (r?.command == undefined) {
        toast.error(
          $root.$e("Erreur lors de l'exécution du vol.") + " (" + r + ")",
          $root.toastConfig
        );
      }
    },
  },
};
</script>
